export default __webpack_public_path__ + "static/media/empty.3a2aec33.svg";